import { CircularProgress, DialogActions, makeStyles } from '@material-ui/core';
import Button from './button';
import ModalV2 from './modal-v2';
import Text from './text';

const useStyles = makeStyles({
  actions: {
    padding: '30px 0 0',
  },
});

interface RemoveAnswerModalProps {
  open: boolean;
  isLoading?: boolean;
  onRemove: () => void;
  onClose: () => void;
}

export function RemoveAnswerModal({
  open,
  isLoading,
  onRemove,
  onClose,
}: RemoveAnswerModalProps) {
  const classes = useStyles();

  return (
    <ModalV2
      width='480px'
      open={open}
      onClose={onClose}
      titleProps={{ title: 'Remove Answer' }}>
      <Text variant='normal'>
        Do you really want to remove this answer?
        <br />
        This answer will be permanently removed. If you need this answer in
        Quarterly Reports form in future, please consult with your program
        admin.
      </Text>
      <DialogActions className={classes.actions}>
        <Button
          variant='outlined'
          onClick={onClose}
          data-testid='button-cancel'>
          No
        </Button>
        <Button
          onClick={onRemove}
          disabled={isLoading}
          data-testid='button-success'>
          {isLoading ? <CircularProgress size={24} color='inherit' /> : 'Yes'}
        </Button>
      </DialogActions>
    </ModalV2>
  );
}
